export default __webpack_public_path__ + "static/media/discount-icon.f2bfcb51.svg";